import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);

    this.state = { hasError: false };
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  componentDidUpdate(prevProps) {
    if(this.props.location.pathname !== prevProps.location.pathname) {
      this.setState({hasError: false});
    }
  }

  render() {
    if(this.state.hasError) {
      return <h1 className='ta-center'>Something went wrong. :^(</h1>;
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js